import { Fragment } from "react";
import useScrollStop from "../hooks/use-scroll-stop";
import styles from "./Modal.module.css";
import ReactDOM from "react-dom";

export default function Modal(props) {
  const portalElement = document.getElementById("overlays");

  useScrollStop();

  return (
    <Fragment>
      {ReactDOM.createPortal(
        <Fragment>
          <div className={styles.backdrop} onClick={props.onClose} />
          <div className={styles.wrapper}>{props.children}</div>;
        </Fragment>,
        portalElement
      )}
    </Fragment>
  );
}
